import React, { useState } from "react";
import Header from "../components/Header";
import data from "../data/data.json";

const Crew = () => {
  const crewData = data.crew;
  const [idChoice, setIdChoice] = useState(0);

  const handleChoice = (e) => {
    const crew = e.target.id;

    const choice = crewData.find((item) => item.name === crew);
    console.log(choice);
    if (choice) {
      setIdChoice(crewData.indexOf(choice));
    }
  };
  return (
    <div className="crew-container">
      <Header />
      <main className="crew-content wrapper">
        <h5>
          <span>02</span> Meet your crew
        </h5>
        <div className="crew-content-container">
          <div className="img-container">
            <img
              src={crewData[idChoice].images.png}
              alt={crewData[idChoice].name}
            />
          </div>

          <div className="crew-radio-description">
            <ul className="radio-container">
              {crewData.map((crew, index) => {
                return (
                  <li key={index}>
                    <input
                      type="radio"
                      name="crew"
                      id={crew.name}
                      onInput={(e) => handleChoice(e)}
                      defaultChecked={index === 0}
                    />
                    <label htmlFor={crew.name}></label>
                  </li>
                );
              })}
            </ul>

            <div className="crew-content-description">
              <h4>{crewData[idChoice].role}</h4>
              <h3>{crewData[idChoice].name}</h3>
              <p>{crewData[idChoice].bio}</p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Crew;
